import type { IconSvgObject } from './types';

const MobileProgramming02Icon: IconSvgObject = [
  ["path", { d: "M5 6.5L5.0006 3.9997C5.00086 2.89533 5.89619 2.00019 7.00057 2.00018L17 2.00003C18.1046 2.00001 19 2.89545 19 4.00003V6.5M5 17.5V20C5 21.1046 5.89543 22 7 22H17.0005C18.1053 22 19.0008 21.1043 19.0005 19.9996L19 17.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M11 19H13", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M17.5 9.5L20 12L17.5 14.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M6.5 9.5L4 12L6.5 14.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default MobileProgramming02Icon;
